export enum StorageTableNames {
  TICKETS = 'tickets',
  TICKET_CHECKINS = 'ticketCheckins',
  FINGERPRINTS = 'fingerprints',
}
